export default __webpack_public_path__ + "static/media/tetra-web.5b1e14db.gif";